/*
 * recommended-product (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { recommendedProducts } from "./recommended-product.schema"

/* Select */
export type RecommendedProduct = z.infer<typeof selectRecommendedProductSchema>
export const selectRecommendedProductSchema = createSelectSchema(recommendedProducts)

/* Filters */
export type RecommendedProductFilters = z.infer<typeof recommendedProductFiltersSchema>
export const recommendedProductFiltersSchema = z.object({
	id: z.string().optional(),
	treatmentId: z.string().optional(),
	productId: z.string().optional(),
	patientId: z.string().optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createRecommendedProductSchema = createInsertSchema(recommendedProducts).partial(globalCreateExclude)
export type CreateRecommendedProduct = z.infer<typeof createRecommendedProductSchema>

/* Update */
export const updateRecommendedProductSchema = createInsertSchema(recommendedProducts)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateRecommendedProduct = z.infer<typeof updateRecommendedProductSchema>
